import { Components } from 'react-virtuoso';
import React from 'react';
import { Grid } from '@cad-arc';

export const FrQueueVirtuosoListWrapper: Components['List'] = React.forwardRef(
    function FrQueueVirtuosoListWrapper({ children, style, ...rest }, ref) {
        return (
            <Grid
                // this opts us out of the browser's default behavior of minimizing content shifts.
                // in our queues we want content to shift when the list is being sorted
                style={{
                    ...style,
                    overflowAnchor: 'none',
                }}
                ref={ref}
                {...rest}
            >
                {children}
            </Grid>
        );
    }
);
